import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RegisterUserAutoLoginMutationVariables = Types.Exact<{
  model: Types.Scalars['JSON']['input'];
  xTenantId: Types.Scalars['String']['input'];
}>;


export type RegisterUserAutoLoginMutation = { __typename?: 'Mutation', registerUserAutoLogin?: { __typename?: 'RegisterAutoLoginResponse', data: boolean, registrationData?: { __typename?: 'RegistrationAutoLoginResponse', userProfileId?: string | null, isAutoLoginEnabled?: boolean | null, oneTimeAuthToken?: string | null } | null } | null };


export const RegisterUserAutoLoginDocument = gql`
    mutation registerUserAutoLogin($model: JSON!, $xTenantId: String!) {
  registerUserAutoLogin(model: $model, xTenantID: $xTenantId) {
    data
    registrationData {
      userProfileId
      isAutoLoginEnabled
      oneTimeAuthToken
    }
  }
}
    `;
export type RegisterUserAutoLoginMutationFn = Apollo.MutationFunction<RegisterUserAutoLoginMutation, RegisterUserAutoLoginMutationVariables>;

/**
 * __useRegisterUserAutoLoginMutation__
 *
 * To run a mutation, you first call `useRegisterUserAutoLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserAutoLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserAutoLoginMutation, { data, loading, error }] = useRegisterUserAutoLoginMutation({
 *   variables: {
 *      model: // value for 'model'
 *      xTenantId: // value for 'xTenantId'
 *   },
 * });
 */
export function useRegisterUserAutoLoginMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserAutoLoginMutation, RegisterUserAutoLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserAutoLoginMutation, RegisterUserAutoLoginMutationVariables>(RegisterUserAutoLoginDocument, options);
      }
export type RegisterUserAutoLoginMutationHookResult = ReturnType<typeof useRegisterUserAutoLoginMutation>;
export type RegisterUserAutoLoginMutationResult = Apollo.MutationResult<RegisterUserAutoLoginMutation>;
export type RegisterUserAutoLoginMutationOptions = Apollo.BaseMutationOptions<RegisterUserAutoLoginMutation, RegisterUserAutoLoginMutationVariables>;